@import './sol-button';

.sol-button-medium {
  padding: 8px 12px;
}

.sol-button-large {
  padding: 14px 24px;
  gap: var(--spacing-075, 12px);
}
